export enum ImportType {
  Excel = "Excel",
  Text = "Text",
  BMEcat = "BMEcat",
  ExternalSource = "ExternalSource"
}

export enum ImportSection {
  Source = "source",
  Mapping = "mapping",
  ImportRules = "importRules",
  Options = "options",
  ArticleNoFilter = "articleNoFilter"
}

export enum ArticleHandling {
  FetchOrCreate = "FetchOrCreate",
  FetchOnly = "FetchOnly",
  Delete = "Delete"
}
